import OperacoesCdaWa from '@/views/operacoes-cda-wa/OperacoesCdaWa';
import NovaOperacaoCdaWa from '@/views/operacoes-cda-wa/NovaOperacaoCdaWa';
import VisualizarOperacaoCdaWa from '@/views/operacoes-cda-wa/VisualizarOperacaoCdaWa';
import MonitoramentoOperacaoCdaWa from '@/views/operacoes-cda-wa/monitoramento/MonitoramentoOperacaoCdaWa';

export const rotasOperacoesCdaWa = [
    {
        path: '/operacoes-cda-wa',
        name: 'OperacoesCdaWa',
        meta: {
            roles: [
                'ROLE_ADMINISTRATOR',
                'ROLE_REGULAR',
                'ROLE_OPERACAO_CDA_WA'
            ]
        },
        component: OperacoesCdaWa
    },
    {
        path: '/operacoes-cda-wa/nova-operacao',
        name: 'NovaOperacaoCdaWa',
        meta: {
            roles: [
                'ROLE_ADMINISTRATOR',
                'ROLE_REGULAR',
                'ROLE_OPERACAO_CDA_WA'
            ]
        },
        component: NovaOperacaoCdaWa
    },
    {
        path: '/operacoes-cda-wa/visualizar-operacao/:idOperacao',
        name: 'VisualizarOperacaoCdaWa',
        meta: {
            roles: [
                'ROLE_ADMINISTRATOR',
                'ROLE_REGULAR',
                'ROLE_OPERACAO_CDA_WA'
            ]
        },
        component: VisualizarOperacaoCdaWa
    },
    {
        path: '/operacoes-cda-wa/:idOperacao/monitoramento',
        name: 'operacaoMonitoramentoCdaWa',
        meta: {
            roles: [
                'ROLE_ADMINISTRATOR',
                'ROLE_REGULAR',
                'ROLE_OPERACAO_CDA_WA'
            ]
        },
        component: MonitoramentoOperacaoCdaWa
    }
];
